export default [
  {
    path: '/Video/:id?/:lid?',
    name: 'Video',
    component: () => import(/* webpackPrefetch: true */ '../views/course'),
  },
  //课程兼容新前端
  {
    path: '/lessonInfo',
    redirect: (to) =>({
        path: `/Video/${to.query.nmiids || to.query.id}`,
        query: to.query,
      })
  },
  //课程兼容教练端
  {
    path: '/:c(c_details|c_share)/:id/:cid?',
    redirect: (to) =>({
        path: `/Video/${[to.params.id, to.params.cid]
        .filter((i) => i)
        .join('/')}`,
        query: to.query,
      })
  },
  {
    path: '/card/:id/:cid?',
    name: 'Card',
    component: () => import('@/views/course/Card'),
  },
  {
    path: '/Commenting/:id',
    name: 'Commenting',
    component: () => import('@/views/course/Commenting'),
  },
  {
    path: '/wish/:id',
    name: 'Wish',
    component: () => import('@/views/course/Wish'),
  },
  {
    //兼容老链接
    path: '/myInfo',
    redirect: '/My',
  },
  {
    path: '/My',
    name: 'My',
    component: () => import('@/views/my'),
  },
  {
    path: '/Curriculum',
    name: 'Curriculum',
    component: () => import('@/views/my/Curriculum'),
  },
  {
    path: '/Order',
    name: 'Order',
    component: () => import('@/views/my/Order'),
  },
  {
    path: '/Share',
    name: 'Share',
    component: () => import('@/views/my/Share'),
  },
  {
    path: '/Operatproposal',
    name: 'Operatproposal',
    component: () => import('@/views/my/Operatproposal'),
  },
  {
    path: '/Talentrecruitment',
    name: 'Talentrecruitment',
    component: () => import('@/views/my/Talentrecruitment'),
  },
  {
    path: '/Talentdetail',
    name: 'Talentdetail',
    component: () => import('@/views/my/Talentdetail'),
  },
  {
    path: '/Authentication',
    name: 'Authentication',
    component: () => import('@/views/my/Authentication'),
  },
  {
    path: '/c_modifyphone',
    name: 'ModifyPhone',
    component: () => import('@/views/my/Authentication/Modify_phone'),
    meta: {
      title: '修改手机号码',
    },
  },
  {
    path: '/c_bindphone',
    name: 'BindPhone',
    component: () => import('@/views/my/Authentication/Bind_phone'),
    meta: {
      title: '绑定手机',
    },
  },
  {
    path: '/delAcc',
    name: 'DelAcc',
    component: () => import('@/views/my/Authentication/delAcc'),
    meta: {
      title: '注销账号',
    },
  },
  {
    path: '/delAccErr',
    name: 'delAccErr',
    component: () => import('@/views/my/Authentication/delAccErr.vue'),
    meta: {
      title: '注销账号',
    },
  },
  {
    path: '/delAccInfo',
    name: 'delAccInfo',
    component: () => import('@/views/my/Authentication/delAccInfo.vue'),
    meta: {
      title: '注销账号',
    },
  },
  {
    path: '/line',
    name: 'Line',
    component: () => import('@/views/line'),
    meta: {
      title: '线路图下载',
    },
  },
  {
    path: '/linecard/:id',
    name: 'Linecard',
    component: () => import('@/views/line/Linecard'),
  },
  {
    path: '/nlinecard/:id',
    name: 'NLinecard',
    component: () => import('@/views/line/NLinecard'),
  },
  {
    path: '/Code',
    name: 'Code',
    component: () => import('@/views/Code'),
  },
  {
    path: '/update',
    name: 'Update',
    component: () => import('@/views/Update'),
  },
  {
    path: '/Map',
    name: 'Map',
    component: () => import('@/views/Map'),
  },
  {
    path: '/c_goods',
    name: 'Goods',
    component: () => import('@/views/goods'),
    meta: {
      title: '商品详情',
    },
  },
  {
    path: '/prods',
    name: 'Prods',
    component: () => import('@/views/products/lists.vue'),
  },
  {
    path: '/prod_detail/:id',
    name: 'ProdDetail',
    component: () => import('@/views/products/detail.vue'),
  },
  {
    path: '/prod_info/:order_sn',
    name: 'ProdInfo',
    component: () => import('@/views/products/info.vue'),
  },
  {
    path: '/prod_kf/:order_sn',
    name: 'ProdKf',
    component: () => import('@/views/products/kf.vue'),
  },
  {
    path: '/prod_order/:order_sn',
    name: 'ProdOrder',
    component: () => import('@/views/products/order.vue'),
  },
  {
    path: '/prod_oLst',
    name: 'ProdOLst',
    component: () => import('@/views/products/olist.vue'),
  },

  {
    path: '/coupons',
    name: 'Coupons',
    component: () => import('@/views/coupons/index.vue'),
  },

  {
    path: '/coupons/intro/:id',
    name: 'CouponsIntro',
    component: () => import('@/views/coupons/intro.vue'),
  },
  {
    path: '/coupons/detail/:sn',
    name: 'CouponsDetail',
    component: () => import('@/views/coupons/detail.vue'),
  },
    {
    path: '/emsDetail',
    name: 'emsDetail',
    component: () => import('@/views/ems/detail'),
    meta: {
      title: '获取免费线路图',
    },
  },
  {
    path: '/emsExam',
    name: 'emsExam',
    component: () => import('@/views/ems/exam'),
    meta: {
      title: '线路图申请审核',
    },
  },
  {
    path: '/',
    alias: '/Home',
    name: 'Home',
    component: () => import('@/views/Home'),
  },
  {
    path: '/:catchAll*',
    redirect: '/',
  },
];
